import { render } from "./overview_of_profile.html?vue&type=template&id=12b34804&scoped=true&external"
import script from "./overview_of_profile.js?vue&type=script&lang=js&external"
export * from "./overview_of_profile.js?vue&type=script&lang=js&external"

import "./OverviewOfProfile.vue?vue&type=style&index=0&id=12b34804&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12b34804"]])

export default __exports__